import { GetCheckedAddress } from './types'

export function getCheckedAddress({ currentState, newState }: GetCheckedAddress) {
  if (typeof newState === 'string') {
    return newState
  }
  if (typeof currentState === 'object') {
    return { ...currentState, ...newState }
  }

  return newState
}
